import { useQueryClient } from '@tanstack/react-query'
import { ModalProps } from 'antd'
import { Modal } from 'antd/lib'

import { usePersonsServiceGetPersonListByDataEndpointKey } from 'src/api/queries'
import { useLocales } from 'src/locales'

import { PersonalDataSearch } from './components'

type Props = {
  onCancel: () => void
} & ModalProps

export const TutorSection = ({ onCancel, ...props }: Props) => {
  const { t } = useLocales()

  const queryClient = useQueryClient()

  const handleCancel = () => {
    queryClient.removeQueries({
      queryKey: [usePersonsServiceGetPersonListByDataEndpointKey],
      exact: false
    })
    onCancel()
  }

  return (
    <Modal
      open
      width={900}
      maskClosable={false}
      title={t('persons.add_tutor')}
      centered
      footer={false}
      onCancel={handleCancel}
      {...props}
    >
      <PersonalDataSearch onCancel={handleCancel} />
    </Modal>
  )
}
